var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 form-msg has-text-centered",class:_vm.submitedForm.status === 'submited' ? 'form-success' : 'form-error',staticStyle:{"width":"300px"}},[(_vm.submitedForm.status === 'submited')?_c('p',{domProps:{"innerHTML":_vm._s(_vm.submitedForm.msg)}}):_c('p',{domProps:{"innerHTML":_vm._s(_vm.submitedForm.msg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }